/* eslint-disable jsx-a11y/label-has-for */

// node modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { fieldPropTypes } from 'redux-form';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

// app: services
import { isAndroidApp } from 'services/environment';

// assets
import CssField from '../Field.scss';
import CssInput from './Input.scss';

class Input extends PureComponent {
  static propTypes = {
    type: PropTypes.string,
    togglePasswordVisibility: PropTypes.func,
    showPassword: PropTypes.bool,
    defaultFocus: PropTypes.bool,
    renderError: PropTypes.node,
    noPasswordError: PropTypes.node,
    ...fieldPropTypes,
  };

  static defaultProps = {
    type: 'text',
    togglePasswordVisibility: null,
    showPassword: false,
    defaultFocus: false,
    renderError: null,
    noPasswordError: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      isFocused: props.defaultFocus,
    };

    this.inputRef = React.createRef();
    this.handleToggleVisibility = this.handleToggleVisibility.bind(this);
  }

  onFocus = event => {
    const { input } = this.props;
    // Android needs a bit of help keeping form elements in view when tabbing through forms.
    if (isAndroidApp()) {
      event.persist();
      setTimeout(() => {
        event.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 0);
    }
    this.setState({ isFocused: true });
    if (input.onFocus) {
      return input.onFocus(event);
    }
    return true;
  };

  onBlur = () => {
    this.setState({ isFocused: false });
  };

  handleToggleVisibility = event => {
    event.preventDefault();
    const { togglePasswordVisibility } = this.props;
    if (togglePasswordVisibility) {
      togglePasswordVisibility();
    }
    this.inputRef.current.focus();
  };

  renderErrorMessage = () => {
    const {
      meta: { touched, error },
      input: { value },
      renderError,
      noPasswordError,
      type,
    } = this.props;

    if (noPasswordError) {
      return noPasswordError;
    }

    if (!touched) {
      return null;
    }

    if (error && renderError) {
      if (type === 'email') {
        return error === 'in_use' ? renderError(value) : error;
      }
      return renderError();
    }

    return error;
  };

  render() {
    const {
      input,
      label,
      type,
      meta: { touched, error, form },
      togglePasswordVisibility,
      showPassword,
      className,
      labelClassName,
    } = this.props;
    const id = `${form}-${input.name}`;
    const inputClassNames = classNames(
      'field__input',
      { 'field__input--error': touched && error },
      className,
    );
    const labelClassNames = classNames(
      'field__label',
      { 'field__label--error': touched && error },
      labelClassName,
    );

    const { isFocused } = this.state;

    return (
      <div className="field field--input">
        <div
          className={`field__wrapper field__wrapper--with-icon ${isFocused ? 'input-focused' : ''}`}
        >
          <input
            id={id}
            ref={this.inputRef}
            className={inputClassNames}
            type={togglePasswordVisibility && showPassword ? 'text' : type}
            {...input}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
          />
          {type === 'password' && (
            <span onClick={this.handleToggleVisibility} className="password-icon">
              {showPassword ? (
                <VisibilityIcon fontSize="small" />
              ) : (
                <VisibilityOffIcon fontSize="small" />
              )}
            </span>
          )}
          <label htmlFor={id} className={labelClassNames}>
            {label}
          </label>
        </div>
        <div className="field__message">{this.renderErrorMessage()}</div>
      </div>
    );
  }
}

export default withStyles(CssField, CssInput)(Input);
